"use strict";

$(document).ready(function () {
  $(document).ajaxComplete(function (event, xhr, settings) {
    if (settings.url.indexOf("formbuilder") !== -1) {
      window.scrollTo(0, 0);
    }
  });
});